import { assign } from 'xstate';

export const setUsageKnown = assign(({ context }) => {
  return { ...context, isUsageKnown: true };
});
